import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getLiveStream = () => {
  const url = API_URLS.liveStream;
  return axiosClient.get(url);
};
export const getLiveStreamList = () => {
  const url = API_URLS.liveStreamList;
  return axiosClient.get(url);
};
export const getCampaignDetails = (id) => {
  const url = API_URLS.campaignDetails(id);
  return axiosClient.get(url);
};
export const getBannerDetails = (id) => {
  const url = API_URLS.bannerDetails(id);
  return axiosClient.get(url);
};
